import(/* webpackMode: "eager" */ "/vercel/path0/apps/kiosk/src/app/[lng]/events/page.tsx");
